export const db = [
  {
    lat: 39.55,
    lng: 46.00,
    date: "21-06-2017",
  },
  {
    lat: 40.11,
    lng: 45.68,
    date: "21-06-2017"
  },
  {
    lat: 41.12,
    lng: 44.83,
    date: "12-10-2018"
  },
  {
    lat: 43.67,
    lng: -70.80,
    date: "19-10-2012"
  },
  {
    lat: 21.80,
    lng: 91.50,
    date: "28-01-2013"
  },
  {
    lat: -3.01,
    lng: -23.42,
    date: "19-11-1969"
  },
  {
    lat: 26.08,
    lng: 3.66,
    date: "31-07-1971"
  },
  {
    lat: -8.97,
    lng: 15.49,
    date: "21-04-1975"
  },
  {
    lat: -9.12,
    lng: 15.50,
    date: "30-09-1977"
  },
  {
    lat: -30.95,
    lng: 22.24,
    date: "06-09-1998"
  },
 {
    lat: 34.24,
    lng: -118.53,
    date: "18-01-1994"
 },
 {
    lat: 44.29,
    lng: -124.08,
    date: "31-12-2009"
 },
 {
    lat: 27.74,
    lng: 89.73,
    date: "12-01-2002"
 },
 {
    lat: -77.73,
    lng: 162.27,
    date: "08-12-2004"
 },
 {
    lat: 31.05,
    lng: -4.01,
    date: "03-05-2010"
 },
 {
    lat: -3.64,
    lng: -17.47,
    date: "05-02-1971"
 },
 {
    lat: -77.73,
    lng: 162.24,
    date: "26-11-2004"
 }
]